module.exports = __webpack_public_path__ + "media/images/stars-466a38df43bcf50a2a230f04a51a70e6432480236f69e27785aeaf66f183de69.jpg";